import { render, staticRenderFns } from "./HelptipPopup.vue?vue&type=template&id=85adb7aa&scoped=true"
import script from "./HelptipPopup.vue?vue&type=script&lang=js"
export * from "./HelptipPopup.vue?vue&type=script&lang=js"
import style0 from "./HelptipPopup.vue?vue&type=style&index=0&id=85adb7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85adb7aa",
  null
  
)

export default component.exports